import(/* webpackMode: "eager" */ "/home/runner/work/joydrop-ui/joydrop-ui/src/app/error.tsx");
